/* eslint-disable max-len */
import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import { userCutawayStatus } from "@helpers/UserCutawayStatus";
import { InputAutocomplete } from "@components/form/index";
import { NetworkingFillStatus } from "@interface/enums";

interface PropsInterface extends Type.ComponentInterface {
  event_id: number;
}

interface StateInterface {
  invited_employees: number[];
}

class Default extends React.Component<PropsInterface, StateInterface> {
  constructor(props: PropsInterface) {
    super(props);
    this.state = {
      invited_employees: [],
    };
  }

  public componentDidMount() {
    console.log("MY COMPANY: ", this.props.Store.Auth.data.company);
    if (this.props.Store.Auth.data.company) {
      Middleware.Company.Employee.load(this.props.Store.Auth.data.company.id);
    } else {
      console.log("WARNING: You has no company.");
    }

    this.props.Store.Event.data?.participantList?.forEach(
      (User: any, index: number) => {
        const invited_employees = this.state.invited_employees;
        invited_employees.push(User.id);
        this.setState({ invited_employees });
      }
    );
  }

  public render() {
    return (
      <>
        <div className="modal modal--stand-users modal--new-event-user">
          <div className="modal__header">
            <div className="modal__title">Присоединить участников</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <hr />
          {!this.props.Store.Company.Employee.list?.filter(
            (User: any) => User.id !== this.props.Store.Auth.data.id
          ).length ? (
            <></>
          ) : (
            <>
              <div className="modal__body">
                <div className="modal__body-title">Ваши коллеги</div>
                <div className="modal__grid">
                  {this.props.Store.Company.Employee.list
                    ?.filter(
                      (User: any) => User.id !== this.props.Store.Auth.data.id
                    )
                    .map((User: any) => {
                      return (
                        <div key={User.id} className="stand-user">
                          <a
                            target="_blank"
                            href={`/user/${User.id}`}
                            className="stand-user__body"
                          >
                            <div className="stand-user__img">
                              {User.userImage ? (
                                <img src={User.userImage} alt={User.fullName} />
                              ) : (
                                <div className="stand-user__img-placeholder" />
                              )}
                            </div>
                            <div className="stand-user__name">
                              {User.firstName} {User.lastName}
                            </div>
                            <div className="stand-user__position">
                              {User.position}
                            </div>
                          </a>
                          {this.state.invited_employees.includes(User.id) ? (
                            <></>
                          ) : (
                            // <div className="stand-user__footer">
                            //   <Link
                            //     className={`btn btn--white-grey ${userCutawayStatus(User)}`}
                            //     to="#"
                            //     // onClick={() => Middleware.User.Cutaway.invite(User.id)}
                            //     // onClick={() => Middleware.Ui.Modal.open("ComingSoon")}
                            //     onClick={() => {
                            //       console.log("bugfix");
                            //       if (this.props.Store.Auth.data.networkingFillStatus === NetworkingFillStatus.Complete) {
                            //         Middleware.User.Event.reject(Number(this.props.event_id), {
                            //           description: "Запрос отклонен.",
                            //         }).then(() => Middleware.Event.load(Number(this.props.event_id)));
                            //       } else {
                            //         Middleware.Ui.Modal.open("HasNoProfile");
                            //       }
                            //     }}
                            //   >
                            //     Убрать{" "}
                            //     <svg
                            //       width="7"
                            //       height="7"
                            //       viewBox="0 0 7 7"
                            //       fill="none"
                            //       xmlns="http://www.w3.org/2000/svg"
                            //     >
                            //       <path
                            //         fillRule="evenodd"
                            //         clipRule="evenodd"
                            //         d="M3.5 0C3.63261 0 3.75979 0.0526785 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V3H6.5C6.63261 3 6.75979 3.05268 6.85355 3.14645C6.94732 3.24021 7 3.36739 7 3.5C7 3.63261 6.94732 3.75979 6.85355 3.85355C6.75979 3.94732 6.63261 4 6.5 4H4V6.5C4 6.63261 3.94732 6.75979 3.85355 6.85355C3.75979 6.94732 3.63261 7 3.5 7C3.36739 7 3.24021 6.94732 3.14645 6.85355C3.05268 6.75979 3 6.63261 3 6.5V4H0.5C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526785 3.75979 0 3.63261 0 3.5C0 3.36739 0.0526785 3.24021 0.146447 3.14645C0.240215 3.05268 0.367392 3 0.5 3H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526785 3.36739 0 3.5 0Z"
                            //         fill="#FF0011"
                            //       />
                            //     </svg>
                            //   </Link>
                            // </div>
                            <div className="stand-user__footer">
                              <Link
                                className="btn btn--white-red"
                                to={`/user/${User.id}/event/create`}
                                // onClick={() => Middleware.Ui.Modal.open("ComingSoon")}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    this.props.Store.Auth.data
                                      .networkingFillStatus ===
                                    NetworkingFillStatus.Complete
                                  ) {
                                    Middleware.User.Event.invite(
                                      User.id,
                                      Number(this.props.event_id)
                                    ).then(() => {
                                      Middleware.Company.Employee.load(
                                        this.props.Store.Auth.data.company?.id
                                      ).then((data) => {
                                        // data.forEach((Employee) => {
                                        const invited_employees =
                                          this.state.invited_employees;
                                        invited_employees.push(User.id);
                                        this.setState({ invited_employees });
                                        // });
                                      });
                                      Middleware.Event.load(
                                        Number(this.props.event_id)
                                      );
                                    });
                                  } else {
                                    Middleware.Ui.Modal.open("HasNoProfile");
                                  }
                                }}
                              >
                                Добавить{" "}
                                <svg
                                  width="7"
                                  height="7"
                                  viewBox="0 0 7 7"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.5 0C3.63261 0 3.75979 0.0526785 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V3H6.5C6.63261 3 6.75979 3.05268 6.85355 3.14645C6.94732 3.24021 7 3.36739 7 3.5C7 3.63261 6.94732 3.75979 6.85355 3.85355C6.75979 3.94732 6.63261 4 6.5 4H4V6.5C4 6.63261 3.94732 6.75979 3.85355 6.85355C3.75979 6.94732 3.63261 7 3.5 7C3.36739 7 3.24021 6.94732 3.14645 6.85355C3.05268 6.75979 3 6.63261 3 6.5V4H0.5C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526785 3.75979 0 3.63261 0 3.5C0 3.36739 0.0526785 3.24021 0.146447 3.14645C0.240215 3.05268 0.367392 3 0.5 3H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526785 3.36739 0 3.5 0Z"
                                    fill="#FF0011"
                                  />
                                </svg>
                              </Link>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>

              <hr />
            </>
          )}
          <div className="modal__body">
            <div className="modal__body-title">
              Представители других компаний
            </div>
            <div className="modal__grid">
              {this.props.Store.Event.data?.participantList
                ?.filter(
                  (User: any) =>
                    User.company?.id !== this.props.Store.Auth.data.company?.id
                )
                .map((User: any) => {
                  return (
                    <div key={User.id} className="stand-user">
                      <a
                        target="_blank"
                        to={`/user/${User.id}`}
                        className="stand-user__body"
                      >
                        <div className="stand-user__img">
                          {User.userImage ? (
                            <img src={User.userImage} alt={User.fullName} />
                          ) : (
                            <div className="stand-user__img-placeholder" />
                          )}
                        </div>
                        <div className="stand-user__name">
                          {User.firstName} {User.lastName}
                        </div>
                        <div className="stand-user__position">
                          {User.position}
                        </div>
                      </a>
                    </div>
                  );
                })}
            </div>
            <InputAutocomplete
              name="user"
              type="user"
              placeholder="Имя, фамилия, email"
              searchIcon={true}
              clearOnSelect={true}
              onSelect={(e: any) => {
                let ProgressAlert: any;
                Middleware.Ui.Alert.open("Process", {
                  text: "Добавляем пользователя...",
                  component: (c: any) => (ProgressAlert = c),
                });
                Middleware.User.Event.invite(
                  Number(e.target.value),
                  Number(this.props.event_id)
                )
                  .then(() => {
                    ProgressAlert.setText("Пользователь добавлен");
                    ProgressAlert.setStatus("success");
                    ProgressAlert.startTimer();
                    Middleware.Event.load(Number(this.props.event_id));
                  })
                  .catch((Exception) => {
                    ProgressAlert.setText("Ошибка: " + Exception.error);
                    ProgressAlert.setStatus("danger");
                    ProgressAlert.startTimer();
                  });
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
